uvex-commerce-connector {
  display: block;
}

#cci-inline-root {
  width: 100%;
  padding: 0 0.25rem;
}
#cci-inline-root [data-ccid='inline-bno'] {
  border-top: 0 none;
  padding: 0;
}
#cci-inline-root .cc-BNOInlineItem-module-panel_ovwxB {
  border-radius: 0;
}
#cci-inline-root #variantDropdownList {
  max-height: 200px;
  z-index: 999;
}
@media (max-width: 1499px) {
  #cci-inline-root [data-ccid='wtb-sticky-button'] {
    display: none;
  }
}
